import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-gray-900 py-8 px-4 sm:px-6 lg:px-8 border-t border-gray-800" data-id="element-16">
      <div className="max-w-7xl mx-auto" data-id="element-17">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-18">
          <div className="mb-4 md:mb-0" data-id="element-19">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/2c6dce52-3a64-4bfa-a2a2-ec0b6bf9870c/tactical_investor_mastermind.png" alt="Tactical Investor Mastermind Logo" className="h-10 w-auto" data-id="element-20" />
          </div>
          <div className="flex flex-col md:flex-row md:space-x-8 items-center" data-id="element-21">
            <Link to="/contact" className="text-gray-400 hover:text-white" data-id="element-22">
              Contact Us
            </Link>
          </div>
        </div>
        <div className="mt-8 text-center text-gray-400 text-sm" data-id="element-23">
          <p data-id="element-24">
            © {new Date().getFullYear()} Tactical Investor Mastermind. All
            rights reserved.
          </p>
          <p className="mt-2" data-id="element-25">Proudly serving United States Veterans.</p>
        </div>
      </div>
    </footer>;
}